<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img
        id="profile-img"
        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="profile-img-card"
      />
      <Form @submit="handleRegister" :validation-schema="schema">
        <div v-if="!successful">
          <div class="form-group">
            <label for="username">Usuário</label>
            <Field
              name="username"
              type="text"
              class="form-control"
              v-model="user.name"
            />
            <ErrorMessage name="username" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <Field
              name="email"
              type="email"
              class="form-control"
              v-model="user.email"
            />
            <ErrorMessage name="email" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="type">Tipo</label>
              <Field name="type" as="select" class="form-control" v-model="user.type">
                <option value="user">Usuario</option>
                <option value="supervisor">Supervisor</option>
                <option value="admin">Administrador</option>
              </Field>
              <ErrorMessage name="type" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="supervisor">Supervisor</label>
              <Field name="supervisor" as="select" class="form-control" v-model="user.supervisor">
                <option value="0">Selecione um supervisor</option>
                <option
                  v-for="i in userOptions"
                  :value="i.value"
                  :key="i.value"
                >
                  {{ i.text }}
                </option>
              </Field>
              <ErrorMessage name="supervisor" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="limit">Envio max</label>
            <Field
              name="limit"
              type="number"
              class="form-control"
              v-model="user.limit"
            />
            <ErrorMessage name="limit" class="error-feedback" />
          </div>
          <div class="form-group" v-if="!user.id">
            <label for="password">Senha</label>
            <Field name="password" type="password" class="form-control" />
            <ErrorMessage name="password" class="error-feedback" />
          </div>
          <div class="form-group" v-if="user.id">
            <label for="password1">Senha</label>
            <Field name="password1" type="password" class="form-control" autocomplete="new-password" />
            <ErrorMessage name="password1" class="error-feedback" />
          </div>

          <div class="form-group">
            <button class="btn btn-primary btn-block" :disabled="loading">
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              {{ buttonName }}
            </button>
          </div>
        </div>
      </Form>

      <div
        v-if="message"
        class="alert"
        :class="successful ? 'alert-success' : 'alert-danger'"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import userService from "../services/user.service";

export default {
  name: "Register",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    var schema = yup.object();
    if (this.$route.params.id) {
      schema = yup.object().shape({
        username: yup
          .string()
          .required("Username is required!")
          .min(3, "Must be at least 3 characters!")
          .max(20, "Must be maximum 20 characters!"),
        email: yup
          .string()
          .required("Email is required!")
          .email("Email is invalid!")
          .max(50, "Must be maximum 50 characters!"),
        password1: yup
          .string()
          .max(40, "Must be maximum 40 characters!"),
      });
    } else {
      schema = yup.object().shape({
        username: yup
          .string()
          .required("Username is required!")
          .min(3, "Must be at least 3 characters!")
          .max(20, "Must be maximum 20 characters!"),
        email: yup
          .string()
          .required("Email is required!")
          .email("Email is invalid!")
          .max(50, "Must be maximum 50 characters!"),
        1: yup
          .string()
          .required("Password is required!")
          .min(6, "Must be at least 6 characters!")
          .max(40, "Must be maximum 40 characters!"),
      });
    }
    return {
      user: {
        id: this.$route.params.id,
        name: "",
        email: "",
        limit: "",
        supervisor: 0,
        type: "user",
      },
      buttonName: this.$route.params.id ? "Editar" : "Registrar",
      successful: false,
      loading: false,
      message: "",
      schema,
      userID: "",
      userOptions: [],
    };
  },
  computed: {
    loggedIn() {
      return (this.$store.state.auth.status.loggedIn && this.$store.state.auth.user.validOTP);
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    if (!this.currentUser || !this.loggedIn) {
      this.$root.logOut();
    }
    if (this.loggedIn) {
      UserService.getListSupervisor().then(
        (response) => {
          if (response.data.result) {
            this.userOptions = response.data.data;
          }
          if (this.$route.params.id) {
            UserService.getUser(this.user.id).then(
              (response) => {
                if (response.data.result) {
                  console.log(response.data.data);
                  this.user.name = response.data.data.user;
                  this.user.email = response.data.data.email;
                  this.user.limit = response.data.data.limit;
                  this.user.supervisor = response.data.data.supervisor;
                  this.user.type = response.data.data.type;
                }
              },
              (error) => {
                this.rows = [];
                console.log(
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString()
                );
              }
            );
          }
        },
        (error) => {
          this.userOptions = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
          this.$root.logOut();
        }
      );
    }
  },
  methods: {
    handleRegister(user) {
      this.message = "";
      this.successful = false;
      this.loading = true;
      if (this.user.id) {
        user.id = this.user.id;
        userService.edit(user).then(
          () => {
            this.$router.push("/users");
          },
          (error) => {
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            this.successful = false;
            this.loading = false;
          }
        );
      } else {
        this.$store.dispatch("auth/register", user).then(
          (data) => {
            this.message = data.message;
            this.successful = true;
            this.loading = false;
            this.user.name = "";
            this.user.email = "";
            this.user.limit = "";
            setTimeout(() => {
              this.message = "";
              this.successful = false;
              this.loading = false;
            }, 3000);
          },
          (error) => {
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            this.successful = false;
            this.loading = false;
          }
        );
      }
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
